import styled, { css } from "styled-components";
import { s32, s24, s16, s8, s4, colors, r4, radius } from "@ardoq/design-tokens";
const WithPointerEvents = styled.div`
  pointer-events: auto;
`;
const sizeVariantToToken = {
  none: 0,
  s4,
  s8,
  s16,
  s24,
  s32
};
const Space = styled.div`
  display: flex;
  gap: ${({ $gap = "s16" }) => sizeVariantToToken[$gap]};
  flex-direction: ${({ $isVertical }) => $isVertical ? "column" : "row"};
  align-items: ${({ $align }) => $align || "stretch"};
  justify-content: ${({ $justify }) => $justify || "flex-start"};

  padding: ${({ $padding = "none" }) => sizeVariantToToken[$padding]};
  padding-left: ${({ $paddingLeft }) => $paddingLeft && sizeVariantToToken[$paddingLeft]};
  padding-right: ${({ $paddingRight }) => $paddingRight && sizeVariantToToken[$paddingRight]};
  padding-top: ${({ $paddingTop }) => $paddingTop && sizeVariantToToken[$paddingTop]};
  padding-bottom: ${({ $paddingBottom }) => $paddingBottom && sizeVariantToToken[$paddingBottom]};

  ${({ $flexWrap }) => $flexWrap && css`
      flex-wrap: wrap;
    `}
  ${({ $flex }) => $flex && css`
      flex: ${$flex};
    `}
`;
const disabledCSS = css`
  pointer-events: none;
  opacity: 0.32;
  transition: opacity 0.2s ease-in-out;
`;
const insetFocusRingCSS = css`
  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    pointer-events: none;
    box-shadow: inset 0px 0px 0px 2px ${colors.blue60};
    border-radius: ${r4};
    z-index: 1;
  }
`;
const FOCUS_RING_SPREAD = 3;
const getFocusRingSpreadCSS = css`
  padding: ${FOCUS_RING_SPREAD}px;
  margin: -${FOCUS_RING_SPREAD}px;
`;
const getFocusRingCSS = (offset, color = colors.blue60) => `
  &::before {
    pointer-events: none;
    content: ' ';
    position: absolute;
    top: -${offset}px;
    right: -${offset}px;
    bottom: -${offset}px;
    left: -${offset}px;
    display: block;
    pointer-events: none;
    ${getFocusRingBorderCSS(color)}
    border-radius: ${r4};
    z-index: 1;
  }
`;
const getFocusRingBorderCSS = (color = colors.blue60) => `
  box-shadow:
    0px 0px 0px 1px ${colors.white},
    0px 0px 0px ${FOCUS_RING_SPREAD}px ${color};
`;
const getInsetFocusRingBorderCSS = (color = colors.blue60) => `
  box-shadow:
    inset 0px 0px 0px 2px ${color};
`;
const focusRingCSS = getFocusRingCSS(1);
const focusableCSS = css`
  position: relative;
  &:focus-visible,
  &.focus {
    ${focusRingCSS};
  }
`;
const focusOutline = css`
  outline: 2px solid ${colors.blue60};
  outline-offset: -2px;
  border-radius: ${radius.small};
`;
const hideScrollbars = css`
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;
const ellipsisCSS = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const basicLinkCSS = css`
  color: ${colors.textAction};
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: ${colors.textActionHover};
  }
`;
const errorCSS = css`
  box-shadow: 0px 0px 0px 1px ${colors.borderError};
  &:hover {
    box-shadow: 0px 0px 0px 1px ${colors.borderErrorStrong};
  }
`;
const warningCSS = css`
  box-shadow: 0px 0px 0px 1px ${colors.borderWarning};
  &:hover {
    box-shadow: 0px 0px 0px 1px ${colors.borderWarningStrong};
  }
`;
export {
  FOCUS_RING_SPREAD,
  Space,
  WithPointerEvents,
  basicLinkCSS,
  disabledCSS,
  ellipsisCSS,
  errorCSS,
  focusOutline,
  focusRingCSS,
  focusableCSS,
  getFocusRingBorderCSS,
  getFocusRingCSS,
  getFocusRingSpreadCSS,
  getInsetFocusRingBorderCSS,
  hideScrollbars,
  insetFocusRingCSS,
  sizeVariantToToken,
  warningCSS
};
//# sourceMappingURL=index.js.map
